const PaymentType = {
    path: "",
    name: "",
    redirect: "payment-type",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    meta: {
      requiresAuth: true,
      activeUrl: "/setting",
      isChildren: true,
      lv: 2,
    },
    children: [
      {
        path: "payment-type",
        name: "Payment Type",
        redirect: "payment-type",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        meta: {
          requiresAuth: true,

          activeUrl: "/setting",
          isChildren: true,
          lv: 2,
        },
        children: [
          {
            path: "",
            name: "",
            component: () =>
              import("@/views/pages/setting/settingPage/Payment/PaymentType"),
            meta: {
              requiresAuth: true,

              activeUrl: "/setting",
              isChildren: true,
              lv: 3,
            },
          },
          {
            path: ":id",
            name: "Payment Type Detail",
            redirect: "/setting/payment-type",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            meta: {
              requiresAuth: true,

              activeUrl: "/setting",
              isChildren: true,
              lv: 2,
            },
            children: [
              {
                path: "",
                name: "",
                component: () =>
                  import(
                    "@/views/pages/setting/settingPage/Payment/PaymentType/detail"
                  ),
                meta: {
                  requiresAuth: true,

                  activeUrl: "/setting",
                  isChildren: true,
                  lv: 2,
                },
              },
              // {
            ],
          },
        ],
      },
    ],
  }

  const ReturnPayment = {
    path: "",
    name: "",
    redirect: "return-payment",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    meta: {
      requiresAuth: true,
      activeUrl: "/setting",
      isChildren: true,
      lv: 2,
    },
    children: [
      {
        path: "return-payment",
        name: "Return Payment",
        redirect: "return-payment",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        meta: {
          requiresAuth: true,

          activeUrl: "/setting",
          isChildren: true,
          lv: 2,
        },
        children: [
          {
            path: "",
            name: "",
            component: () =>
              import("@/views/pages/setting/settingPage/Payment/ReturnPayment"),
            meta: {
              requiresAuth: true,

              activeUrl: "/setting",
              isChildren: true,
              lv: 3,
            },
          },
          {
            path: ":id",
            name: "Return Payment Detail",
            redirect: "/setting/return-payment",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            meta: {
              requiresAuth: true,

              activeUrl: "/setting",
              isChildren: true,
              lv: 2,
            },
            children: [
              {
                path: "",
                name: "",
                component: () =>
                  import(
                    "@/views/pages/setting/settingPage/Payment/ReturnPayment/detail"
                  ),
                meta: {
                  requiresAuth: true,

                  activeUrl: "/setting",
                  isChildren: true,
                  lv: 2,
                },
              },
              // {
            ],
          },
        ],
      },
    ],
  }

  const Bank = {
    path: "",
    name: "",
    redirect: "bank",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    meta: {
      requiresAuth: true,
      activeUrl: "/setting",
      isChildren: true,
      lv: 2,
    },
    children: [
      {
        path: "bank",
        name: "Bank",
        redirect: "bank",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        meta: {
          requiresAuth: true,

          activeUrl: "/setting",
          isChildren: true,
          lv: 2,
        },
        children: [
          {
            path: "",
            name: "",
            component: () =>
              import("@/views/pages/setting/settingPage/Payment/Bank"),
            meta: {
              requiresAuth: true,

              activeUrl: "/setting",
              isChildren: true,
              lv: 3,
            },
          },
          {
            path: ":id",
            name: "Bank Detail",
            redirect: "/setting/bank",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            meta: {
              requiresAuth: true,

              activeUrl: "/setting",
              isChildren: true,
              lv: 2,
            },
            children: [
              {
                path: "",
                name: "",
                component: () =>
                  import(
                    "@/views/pages/setting/settingPage/Payment/Bank/detail"
                  ),
                meta: {
                  requiresAuth: true,

                  activeUrl: "/setting",
                  isChildren: true,
                  lv: 2,
                },
              },
              // {
            ],
          },
        ],
      },
    ],
  }

  const PaymentSetting = {
    path: "",
    name: "",
    redirect: "payment",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    meta: {
      requiresAuth: true,
      activeUrl: "/setting",
      isChildren: true,
      lv: 2,
    },
    children: [
      {
        path: "payment",
        name: "Payment",
        redirect: "payment",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        meta: {
          requiresAuth: true,

          activeUrl: "/setting",
          isChildren: true,
          lv: 2,
        },
        children: [
          {
            path: "",
            name: "",
            component: () =>
              import("@/views/pages/setting/settingPage/Payment"),
            meta: {
              requiresAuth: true,

              activeUrl: "/setting",
              isChildren: true,
              lv: 3,
            },
          },
          PaymentType,
          ReturnPayment,
          Bank
        ],
      },
    ],
  }
  export default PaymentSetting;